(function () {
  function tryPlayAll() {
    document.querySelectorAll('video[autoplay]').forEach(function (video) {
      if (video.paused) {
        var p = video.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      }
    });
  }

  document.addEventListener('DOMContentLoaded', tryPlayAll);
  document.addEventListener(
    'loadeddata',
    function (e) {
      if (e.target && e.target.tagName === 'VIDEO' && e.target.autoplay && e.target.paused) {
        var p = e.target.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      }
    },
    true
  );

  var unlocked = false;
  var unlockEvents = ['touchstart', 'click', 'scroll', 'keydown'];
  function unlockOnInteraction() {
    if (unlocked) return;
    unlocked = true;
    tryPlayAll();
    unlockEvents.forEach(function (evt) {
      document.removeEventListener(evt, unlockOnInteraction);
    });
  }
  unlockEvents.forEach(function (evt) {
    document.addEventListener(evt, unlockOnInteraction, { passive: true });
  });
})();
